<template>
    <div class="container-fluid custom-fields">
        <v-title :lineage="[{'Settings':'settings'}]">
            Custom Fields
            <div slot="actions">
                <router-link
                    v-if="$auth.$pages['add-custom-field'].isAllowed"
                    :to="{name: 'add-custom-field', params: {resource}}"
                    class="btn btn-link">Add Custom Field<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
            </div>
        </v-title>
        <div class="grid">
            <div class="grid-item">
                <div class="tile">
                    <r-tabs :divided="true" content-class="no-padding" menu-class="no-margin-bottom">
                        <r-tab
                            v-for="(tab, tabIndex) in tabs"
                            :key="tabIndex"
                            :name="tab.name"
                            :to="{name: 'custom-fields', params: {resource: tab.resource}}">
                            <grid
                                class="no-box-shadow"
                                :columns="defaultColumns(tab.resource)"
                                :provider="getProvider(tab.resource)"
                                v-on="getCompletedDelegate(tabIndex)"
                                :show-column-options="false">
                                <v-no-content slot="no-content">
                                    <span slot="title">It seems that you have no custom fields</span>
                                    <p slot="description">
                                        Create a new custom field for {{tab.name.toLowerCase()}}
                                    </p>
                                    <div slot="actions">
                                        <router-link
                                            v-if="$auth.$pages['add-custom-field'].isAllowed"
                                            :to="{name: 'add-custom-field', params: {resource: tab.resource}}"
                                            class="btn btn-link">Add Custom Field<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
                                    </div>
                                </v-no-content>
                            </grid>
                        </r-tab>
                    </r-tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import {vIcon} from '@/components/form';
    import vNoContent from '@/components/v-no-content';
    import Grid from '@/components/grid/grid';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import ColumnSet from '@/components/grid/columns/column-set';
    import CUSTOM_FIELDS_RESOURCES from '@/data/custom-fields-resources';
    import _ from '@/common/helpers';

    export default {
        name: 'custom-fields',
        components: {
            vTitle, vIcon, Grid, vNoContent,
        },
        mixins: [LoadStateMixin],
        props: {
            resource: {
                type: String,
                required: false,
                default: 'customers',
            },
        },
        data() {
            return {
                tabs: Object.keys(CUSTOM_FIELDS_RESOURCES).map(key => ({
                    resource: CUSTOM_FIELDS_RESOURCES[key],
                    name: _.unKebabCase(CUSTOM_FIELDS_RESOURCES[key]),
                })),
            };
        },
        methods: {
            defaultColumns(resourceType) {
                return new ColumnSet({
                    id: `cf-${resourceType}-list`,
                    store: this.$store,
                    version: 2,
                    defaultColumns: [
                        {
                            name: 'name',
                            type: 'link',
                            to: ({fields}) => ({
                                name: 'update-custom-field',
                                params: {
                                    resource: resourceType,
                                    name: fields.name,
                                },
                            }),
                            predicate: this.$auth.$pages['update-custom-field'].isAllowed,
                            predicateOverride: {
                                type: 'text',
                            },
                            sortable: true,
                            sticky: true,
                        },
                        {
                            name: 'type',
                            sortable: true,
                        },
                        {
                            name: 'description',
                        },
                    ],
                });
            },
            getProvider(type) {
                return () => this.$api(({customFields}) => customFields.getAll({resource: type}));
            },
            getCompletedDelegate(index) {
                if (index === 0) {
                    // return a stop-loading-page delegate for the first tab only
                    return {
                        completed: this.stopLoadingPage,
                    };
                }
                return {};
            },
        },
    };
</script>
